import { TuiDay } from "@taiga-ui/cdk";

/**
 * Builds `/invoice/:clientId/:month/:year` (month 1–12) for InvoiceChargesComponent.
 * Accepts Taiga `TuiDay`, `DD.MM.YYYY` strings (legacy extra-charges edit hydrate),
 * ISO strings, or `Date`.
 */
export function buildInvoiceChargesRouteUrl(
  clientId: string | undefined | null,
  dateValue: unknown,
): string | null {
  const id = clientId != null ? String(clientId).trim() : "";
  if (!id) return null;
  const my = monthYearFromFormDate(dateValue);
  if (!my) return null;
  return `/invoice/${id}/${my.month}/${my.year}`;
}

function monthYearFromFormDate(
  dateValue: unknown,
): { month: number; year: number } | null {
  if (dateValue == null || dateValue === "") return null;
  if (dateValue instanceof TuiDay) {
    const d = dateValue.toLocalNativeDate();
    return { month: d.getMonth() + 1, year: d.getFullYear() };
  }
  if (typeof dateValue === "string") {
    const s = dateValue.trim();
    const dot = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/.exec(s);
    if (dot) {
      const month = parseInt(dot[2], 10);
      const year = parseInt(dot[3], 10);
      if (month >= 1 && month <= 12 && year > 0) {
        return { month, year };
      }
    }
  }
  const d = new Date(dateValue as string | number | Date);
  if (Number.isNaN(d.getTime())) return null;
  return { month: d.getMonth() + 1, year: d.getFullYear() };
}
